import {
  DataProvider,
  GetListResult,
  GetManyParams,
  GetManyResult,
  GetOneParams,
  GetOneResult,
} from 'react-admin'
import { NOTIFICATION_CATEGORIES_URL } from '../../api-urls'
import { get, getWithPagination } from '../../common/fetch.utils'
import {
  filterParamsComposer,
  queryParamsComposer,
} from '../../common/get-by-conditions.utils'
import { TicketAPIGetListParams } from '../../common/ticket-api-get-list.params'
import { NotificationCategoryDto } from '../../dto/system-notifications/notification-category.dto'
import filterMapper from './notification-categories-filter.mapper'
import { mapSortCategoriesParam } from './notification-categories-sort.mapper'

const provider = {
  getList: async (
    resource: string,
    { filter, sort, pagination }: TicketAPIGetListParams,
  ): Promise<GetListResult<NotificationCategoryDto>> => {
    const filterParams = `o=>${filterParamsComposer('o', filter, filterMapper)}`
    const pathParams = queryParamsComposer(
      sort,
      pagination,
      mapSortCategoriesParam,
    )
    const path = `/${filterParams}${(pathParams && `?${pathParams}`) || ''}`

    const {
      data,
      range: { total },
    } = await getWithPagination<NotificationCategoryDto[]>(
      `${NOTIFICATION_CATEGORIES_URL}/GetByConditions`,
      path,
    )

    return Promise.resolve({
      data,
      total,
    })
  },
  getOne: async (
    resource: string,
    { id }: GetOneParams,
  ): Promise<GetOneResult<NotificationCategoryDto>> => {
    const data = await get<NotificationCategoryDto>(
      NOTIFICATION_CATEGORIES_URL,
      `/${id}`,
    )
    return Promise.resolve({
      data,
    })
  },
  getMany: async (
    resource: string,
    { ids }: GetManyParams,
  ): Promise<GetManyResult<NotificationCategoryDto>> => {
    const data = await get<NotificationCategoryDto[]>(
      NOTIFICATION_CATEGORIES_URL,
      `/GetByConditions/e=>new int[] {${ids.toString()}}.Contains(e.Id)`,
    )
    return Promise.resolve({ data })
  },
} as DataProvider

export default provider
